var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14614 1.24806C7.4433 0.516133 8.16138 0 9 0C9.83863 0 10.5567 0.516133 10.8539 1.24806C13.8202 2.06062 16 4.77556 16 7.99961V12.6966L17.8321 15.4445C18.0366 15.7514 18.0557 16.1459 17.8817 16.4711C17.7077 16.7962 17.3688 16.9992 17 16.9992H12.4646C12.2219 18.6952 10.7632 19.999 9 19.999C7.23677 19.999 5.77806 18.6952 5.53545 16.9992H1C0.631206 16.9992 0.292346 16.7962 0.118327 16.4711C-0.0556921 16.1459 -0.0366195 15.7514 0.167951 15.4445L2 12.6966V7.99961C2 4.77556 4.17983 2.06062 7.14614 1.24806ZM7.58535 16.9992C7.79127 17.5817 8.34689 17.9991 9 17.9991C9.65311 17.9991 10.2087 17.5817 10.4146 16.9992H7.58535ZM9 2.99985C6.23858 2.99985 4 5.23832 4 7.99961V12.9994C4 13.1968 3.94156 13.3898 3.83205 13.554L2.86852 14.9993H15.1315L14.168 13.554C14.0584 13.3898 14 13.1968 14 12.9994V7.99961C14 5.23832 11.7614 2.99985 9 2.99985Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.af6bf986b4419337836d8f8fbee2b549.svg";
export { ForwardRef as ReactComponent };